module.exports = __webpack_public_path__ + "img/asterisk.72d6549d.svg";